import React from 'react';
import Jumbotron from 'react-bootstrap/Jumbotron';
import "./index.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPatreon,
} from "@fortawesome/free-brands-svg-icons";
 
const SupportUs = () => {
  return (
    <>
      <Jumbotron style={{ margin: 0, backgroundColor: "#FF424D", borderRadius: 0 }}>
        <div style={{ textAlign: "center" }}>
          <h1>
            <FontAwesomeIcon
              icon={faPatreon}
              className="white-text mr-2"
            />
            <b>
              SUPPORT US ON{" "}
              <a
                rel="noopener noreferrer"
                target="_blank"
                href="https://www.patreon.com/envatohouston2021"
                className="link"
              >
                PATREON
              </a>
              !
            </b>
          </h1>
        </div>
      </Jumbotron>
      <Jumbotron style={{ margin: 0, borderRadius: 0 }}>
        <h1>Talk to us!</h1>
        <p>We primarily communicate using email and Instagram.</p>
        <ul>
          <li>
            Email:{" "}
            <a
              rel="noopener noreferrer"
              target="_blank"
              href="mailto: engato.houston21@gmail.com"
            >
              envato.houston21@gmail.com
            </a>
          </li>
          <li>
            Instagram:{" "}
            <a
              rel="noopener noreferrer"
              target="_blank"
              href="https://www.instagram.com/envatohouston2021/"
            >
              https://www.instagram.com/envatohouston2021/
            </a>
          </li>
          <li>
            Remind:{" "}
            <a
              rel="noopener noreferrer"
              target="_blank"
              href="https://www.remind.com/classes/envatoh"
            >
              https://www.remind.com/classes/envatoh
            </a>
          </li>
        </ul>
      </Jumbotron>
    </>
  );
}
 
export default SupportUs;